/**
 * Step 2 for an HTTP endpoint: the path under the connection's base URL, the
 * inputs each item sends, what a good answer does (for LLM judges), and
 * optionally the output's JSON schema.
 */

import { Field } from "@/components/ui/field";
import type { TargetPickerProps } from "../screens";
import { parseSchema, rowsOf } from "./declared";
import { InputFieldsEditor } from "./input-fields-editor";

export function HttpTargetPicker({ connection, value, onChange, locked }: TargetPickerProps) {
  const schema = parseSchema(value.schemaText);
  return (
    <fieldset disabled={locked} className="flex flex-col gap-4">
      <Field label="Name" htmlFor="http-name" optional hint="How the agent is shown in the workbench.">
        <input
          id="http-name"
          className="inp"
          value={value.agentName ?? ""}
          onChange={(e) => onChange({ agentName: e.target.value })}
        />
      </Field>
      <Field
        label="Path"
        required
        htmlFor="http-path"
        hint={`Each item is POSTed as JSON to ${connection.base_url}${value.path ?? ""}`}
      >
        <input
          id="http-path"
          className="inp font-mono"
          placeholder="/run"
          value={value.path ?? ""}
          onChange={(e) => onChange({ path: e.target.value })}
        />
      </Field>
      <InputFieldsEditor rows={rowsOf(value)} onChange={(rows) => onChange({ inputs: rows })} />
      <Field
        label="Task description"
        htmlFor="http-task"
        optional
        hint="What a good answer does. LLM judges read it."
      >
        <textarea
          id="http-task"
          rows={3}
          className="inp"
          value={value.task ?? ""}
          onChange={(e) => onChange({ task: e.target.value })}
        />
      </Field>
      <details className="flex flex-col gap-2">
        <summary className="cursor-pointer text-[13px] font-semibold">Output schema (optional)</summary>
        <Field
          label="JSON schema of the answer"
          htmlFor="http-schema"
          error={typeof schema === "string" ? schema : undefined}
        >
          <textarea
            id="http-schema"
            rows={5}
            className="inp font-mono text-xs"
            value={value.schemaText ?? ""}
            onChange={(e) => onChange({ schemaText: e.target.value })}
          />
        </Field>
      </details>
    </fieldset>
  );
}
